/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-11-29
 * @brief EHP 도움말 - List 개발
 *
 ********************************************************************/
import React, { useState } from "react";
// UTILS
import * as CONST from "../../../utils/Const";
import HelpTree from "./HelpTree";
import * as Help from "./HelpUtils";
// recoli & state
import { useRecoilValue } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
//
/**
 * @brief EHP 도움말 - List  컴포넌트
 * @param
 * @returns react components
 */
function HelpMain(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isToggle, setIsToggle] = useState(true);
    const [tree1Depth, setTree1Depth] = useState(1);
    const [tree2Depth, setTree2Depth] = useState(1);
    //  
    let helpMenu = Help.HelpUtil;
    function adminPDF() {
        fetch("https://repoehp.blob.core.windows.net/repoehp-item/help/EHP_%EB%8F%84%EC%9B%80%EB%A7%90(Admin).pdf").then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = "EHP_도움말(Admin)";
                alink.click();
            });
        });
    }
    function userPDF() {
        fetch("https://repoehp.blob.core.windows.net/repoehp-item/help/EHP_%EB%8F%84%EC%9B%80%EB%A7%90.pdf").then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = "EHP_도움말";
                alink.click();
            });
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("main", { className: "container", style: { "cursor": "default" } },
            React.createElement("section", { className: "content" },
                React.createElement("article", { className: "box" },
                    React.createElement("div", { className: "box__body" },
                        React.createElement("div", { className: "content__top" },
                            React.createElement("h2", null, "\uB3C4\uC6C0\uB9D0"),
                            (userInfo.role == CONST.USERROLE_USER) ?
                                // <button type="button" className="btn-filedown">
                                //     <a href="https://repoehp.blob.core.windows.net/repoehp-item/help/EHP_%EB%8F%84%EC%9B%80%EB%A7%90.pdf" target='_blank'>
                                //         <span>PDF Download</span>
                                //     </a>
                                // </button>
                                React.createElement("button", { onClick: () => userPDF(), type: "button", className: "btn-filedown" },
                                    React.createElement("span", null, "PDF Download"))
                                :
                                    // <button type="button" className="btn-filedown">
                                    //     <a href="https://repoehp.blob.core.windows.net/repoehp-item/help/EHP_%EB%8F%84%EC%9B%80%EB%A7%90(Admin).pdf" target='_blank'>
                                    //         <span>PDF Download</span>
                                    //     </a>
                                    // </button>
                                    React.createElement("button", { onClick: () => adminPDF(), type: "button", className: "btn-filedown" },
                                        React.createElement("span", null, "PDF Download"))),
                        React.createElement("div", { className: "content__bottom" },
                            React.createElement("div", { className: `area__left only-depth2 ${isToggle ? "active" : ""}` },
                                React.createElement("div", { className: "box__etc" },
                                    React.createElement("p", null, "Tree Menu"),
                                    React.createElement("button", { type: "button", onClick: () => setIsToggle(false), className: "btn btn-left" },
                                        React.createElement("span", { className: "hide" }, "\uD2B8\uB9AC\uBA54\uB274\uC811\uAE30\uD3BC\uCE58\uAE30"))),
                                React.createElement(HelpTree, { helpMenu: helpMenu, tree1Depth: tree1Depth, setTree1Depth: setTree1Depth, tree2Depth: tree2Depth, setTree2Depth: setTree2Depth, setIsToggle: setIsToggle })),
                            React.createElement("div", { className: "area__right" }, (helpMenu) && helpMenu.map((list, idx) => (React.createElement(React.Fragment, { key: idx }, (list.subMenu) && list.subMenu.map((sublist, jdx) => (React.createElement(React.Fragment, { key: jdx },
                                React.createElement("div", { id: `help_${list.id}-${sublist.sid}`, className: "page-top" },
                                    React.createElement("h3", null, list.mname),
                                    React.createElement("h4", null, sublist.sname)),
                                React.createElement("div", { className: "page-bottom" }, sublist.snameContents.map((content, kdx) => (React.createElement(React.Fragment, { key: kdx },
                                    React.createElement("h5", { style: { whiteSpace: "pre-wrap" } },
                                        kdx + 1,
                                        ". ",
                                        content.procedure),
                                    React.createElement("div", { className: "cont" },
                                        React.createElement("div", { className: "img-wrap" },
                                            React.createElement("img", { src: content.captureImg, alt: "" })))))))))))))))))),
            React.createElement("a", { href: "#", className: "area__left__toggleBtn", onClick: () => setIsToggle(true) },
                React.createElement("span", { className: "hide" }, "\uD2B8\uB9AC\uBA54\uB274\uBCF4\uAE30")))));
}
export default HelpMain;
